import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Guid } from "guid-typescript";

import { UserService } from '../_services';

@Component({
    templateUrl: 'invalidate.component.html',
    standalone: false
})

export class InvalidateComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router) { }

  // Disabling the account is all this page does. The API tells safeguarding (accounts.disabled-notify-email).
  ngOnInit() {
    this.route.queryParams.subscribe(par => {
      if (par.code != null && Guid.isGuid(par.code)) {
        this.userService.disableUserAccount(par.code).subscribe(() => { }, error => {
            this.router.navigate(['/login']);
        });
      }
    });
  }
}